 
<template>
    <div id="navigatorValidationDashboard">

        <NavbarComponent :loadingStatus="loading">Navigator Interpolation Dashboard</NavbarComponent>

        <section class="section">

            <div class="columns">
                <div class="column is-one-quarter">
                    <!-- Left side Tiles -->

                    <!-- Search Tree Tile -->
                    <div class="box">
                        <!-- search -->
                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-on:keyup.enter="searchNavigator" v-model="searchString" style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="searchNavigator">
                                    Search {{this.$store.getters.lastSelectedTreeName}}
                                </a>
                            </div>
                        </div>

                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-model="searchFilter" placeholder="Filter with *"
                                    style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="addSearchMeters">
                                    Add All Meters
                                </a>
                            </div>
                        </div>


                        <div v-for="item in searchResultFiltered">
                            <SearchResult :item="item"></SearchResult>
                        </div>
                    </div>

                    <!-- Meter Tree Tile -->
                    <div class="box">
                        <!-- dimension select -->
                        <div class="field has-addons">
                            <p class="control">
                                <p class="button is-primary is-small is-secondary primary"> Dimension </p>
                                <p>
                                    <p class="control">
                                        <div class="select is-small">
                                            <select v-model="selectedUserDimension">
                                                <option v-for="(dimension,index) in userDimensions" :value="dimension.id"
                                                    v-bind:selected="index===0">{{dimension.name}}</option>
                                            </select>
                                        </div>

                        </div>


                        <!-- Meter tree -->

                        <treemenu :nodes="this.$store.getters.tree.nodes" :key="this.$store.getters.tree.id" :depth="0"
                            :name="this.$store.getters.tree.name" :id="this.$store.getters.tree.id" :type="this.$store.getters.tree.type"
                            :expandable="this.$store.getters.tree.expandable" ref="tree"></treemenu>
                    </div>
                </div>



                <!-- Right side Tiles -->
                <div class="column x-scrollable-column">
                    <!-- horizontal level for dates-->
                    <div class="box">

                        <b-field grouped group-multiline>
                           <b-field label="Date Range">
                                        <b-select v-model="selectedTimeRange"  size="is-small">
                                            <option value="Yesterday" selected>Yesterday</option>
                                            <option value="Last 24 hours">Last 24 hours</option>
                                            <option value="Last 7 days">Last 7 days</option>
                                            <option value="Last 14 days">Last 14 days</option>
                                            <option value="Last 30 days">Last 30 days</option>
                                            <option value="Last 3 months">Last 3 months</option>
                                            <option value="Last year">Last year</option>
                                            <option value="year to date">Year to Date</option>
                                        </b-select>
                        </b-field>
                        
                           

                            <b-field label = "Start Time: (DD.MM.YYYY HH:mm:ss in local time)">
                                    <b-input  size="is-small" type='text' v-model="localStartTimeStamp">
                                        </b-input>
                                        </b-field>

                                           <b-field label = " End Time: (DD.MM.YYYY HH:mm:ss in local time)">
                                    <b-input  size="is-small" type='text' v-model="localEndTimeStamp">
                                        </b-input>
                                        </b-field>
                   
                       <b-field label = "Override Interpolation Interval (Seconds)">
                                    <b-input  size="is-small" type='number' v-model="intervalSeconds">
                                        </b-input>
                                        </b-field>

                              
                                       

                                    </b-field>
                         
                       
      <b-field grouped group-multiline>

         <b-field>
            <b-checkbox  v-model="nodeRecursiveSearch">  Node Recursive Search</b-checkbox> 
        </b-field>
           <b-field>
            <b-checkbox  v-model="overrideMeterInterval"> Override Meter Original Interval</b-checkbox> 
        </b-field>
        <!--
            <b-field>
            <b-checkbox  v-model="resizeAllGraphs">Resize All Graphs</b-checkbox> 
        </b-field>
        -->
      
        </b-field>
                       


                        <!-- selected meters-->
                        <!-- Meters: <input class="input is-small" type='text' v-model="meterDataIdArray"></input>-->
                        <br>
                        <p><b>Meters to Graph:</b></p>
                         <div v-for="meter in this.$store.getters.meterDataIdNameArray">
              
                            <MeterListItem :meter="meter"></MeterListItem>
                        </div>
                     

                        <br>

                        <!-- horizontal level for control buttons-->
                        <div class="field is-grouped is-grouped-multiline">
                            <p class="control">
                                <button class="button is-primary" @click="getMeterDataButton">Get Meter Data</button>
                            </p>
                            <p class="control">
                                <button class="button is-warning" @click="clearMeters">Clear Meters</button>
                            </p>
                            
                            <p class="control">
                                <button class="button is-dark" @click="saveDataAsCSV">Save Meter Data CSV</button>
                            </p>
                        
                             
   <p class="control">
                                <button class="button is-dark" @click="searchNodesAndAddMetersButton()">    Add Meters From Selected Node
</button>
                            </p>
                               
   <p class="control">

  
                            <download-csv  v-if="finishedMounting"
    class   = "button is-dark"
    :data   = "calculatedTable"
    :labels = '$refs.dataTable.visibleColumns.map(x => x.label)'
    name    = "validationMetersWholeTable.csv">
 
    Download CSV Whole Table
 
</download-csv>

                            </p>

                              <p class="control">
                            <download-csv  v-if="finishedMounting"
    class   = "button is-dark"
    :data   = "$refs.dataTable.visibleData"
    :fields = '$refs.dataTable.visibleColumns.map(x => x.field)'
        :labels = '$refs.dataTable.visibleColumns.map(x => x.label)'
    name    = "validationMetersVisibleTable.csv">
 
    Download CSV Only Visible Table
 
</download-csv>

                            </p>

                              <p class="control">
                                <button class="button is-warning" @click="interpolateAllMeters">Interpolate ALL Meters</button>
                            </p>
                


                        </div>
                  
                         
<b-field grouped group-multiline>
<b-field>
    <!--
                           <b-switch v-model="showValidationOptions">
            </b-switch> Show Table Options
            -->
                </b-field>
                        </b-field>

                    </div>

<div class ="box" v-if="showValidationOptions">
         

    <p><b>Table Columns</b></p>
       <b-field grouped group-multiline>
            <div v-for="(column, index) in tableColumns" 
                :key="index"
                class="control">
                <b-checkbox v-model="column.visible">
{{ column.label }}
                </b-checkbox>
            </div>
        </b-field>

<p><b>Tags to *exclude* in table</b></p>
          <b-field grouped group-multiline>
         
                <b-checkbox v-model="excludeOK">OK</b-checkbox>
        <b-checkbox v-model="excludeNoData">No Data</b-checkbox>
        <b-checkbox v-model="excludeMissingData">Missing Data</b-checkbox>
        <b-checkbox v-model="excludeZeroConsumption">Zero Consumption</b-checkbox>
        <b-checkbox v-model="excludeNegativeZeros">Negative/Zero Readings</b-checkbox>
        <b-checkbox v-model="excludeSpikes">Spikes</b-checkbox>
        <b-checkbox v-model="excludeDoubles">Doubles</b-checkbox>

        </b-field>
<br>
<b-field grouped group-multiline>
    <!--
 <b-field label="Missing Data Minimum Count Threshold"
            type="is-primary"
         >
            <b-input type="number"
            v-model="missingDataMinimumThreshold">
            </b-input>
        </b-field>
-->
       <b-field label="Moving Average Window Length"
            type="is-primary"
         >
            <b-input type="number"
            v-model="spikeMovingAverageWindowLength">
            </b-input>
        </b-field>

       <b-field label="Spikes Multiplicative Threshold"
            type="is-primary"
         >
            <b-input type="number"
            v-model="spikesMultiplicativeThreshold">
            </b-input>
        </b-field>

 <b-field label="Moving Average Minimum Value"
            type="is-primary"
         >
            <b-input type="number"
            v-model="movingAverageMinimum">
            </b-input>
        </b-field>

         <b-field label="Doubles Leniency Threshold Percent"
            type="is-primary"
         >
            <b-input type="number"
            v-model="doublesLeniencyThresholdPercent">
            </b-input>
        </b-field>

         <b-field label="Concurrent Requests Limit"
            
            type="is-primary"
         >
            <b-input type="number"
            v-model="concurrent_requests_limit">
            </b-input>
        </b-field>
</b-field>
</div>

                     <div class="box">
                     
        
  <b-table 
  class="my-table"
  ref="dataTable"
  :data="filteredValidatedTableData" 
  :columns="tableColumns" 
    default-sort="meterName"    
    detailed
    detail-key="meterName"
    @details-open="(row, index) => detailedRowFunction(row, index)">
       <template slot="detail" slot-scope="props">
           <!--
           {{props.row.chartId}}
 <ReactiveChart @relayout_zoom="relayout_graphs" :chart="charts[props.row.chartId]"></ReactiveChart>
 -->
  <NonReactiveChart @relayout_zoom="relayout_graphs" :chart="singleChartData[0]"></NonReactiveChart>
   <button class="button is-primary" @click="postReadingstoNavigator(props.row,props.row.meterId)">Add Interpolated Data</button>
            </template>
    </b-table>
</div>
                 
                </div>
            </div>




        </section>

        <!-- end of app -->
    </div>
</template>

<script>
"use strict";
import treemenu from '@/components/TreeMenu';
import LoadingComponent from '@/components/LoadingComponent';
import ReactiveChart from '@/components/ReactiveChart';
import NonReactiveChart from '@/components/NonReactiveChart';
import MeterListItem from '@/components/MeterListItem';
import SearchResult from '@/components/SearchResult';

import LogoutComponent from '@/components/LogoutComponent';
import moment from 'moment';
import _ from 'lodash';
import saveAs from 'file-saver';
import NavbarComponent from '@/components/NavbarComponent.vue'

//VUE ROOT remove password when ready
export default {
	name: 'navigatorDataDashboard',
    components: {NonReactiveChart, treemenu, LoadingComponent, SearchResult, ReactiveChart, LogoutComponent, NavbarComponent,MeterListItem},
        // Empty data array to initialise axios data into
        data: function() { return { 
            excludeOK: false,
            excludeMissingData: false,
            excludeNoData: false,
            excludeSpikes: false,
            excludeDoubles: false,
            excludeNegativeZeros: false,
            excludeZeroConsumption: false,
            singleChartData: [],
            spikeMovingAverageWindowLength:8,
            movingAverageMinimum: 1,
            spikesMultiplicativeThreshold:100,
            concurrent_requests_limit: 10,
            doublesLeniencyThresholdPercent:25, 
            finishedMounting: false,
            missingDataMinimumThreshold: 3,
            devices: [],
            resizeAllGraphs: false,
            showValidationOptions: false,
        	currentTime: '',
            NavigatorDataType: 'Readings', //readings or consumption
            proxyurl: this.$store.getters.proxyurl,
        	filterLocation: 'NSW',
        	username: this.$store.getters.navigatorUsername,
        	password: this.$store.getters.navigatorPassword, //remove password when ready!
            userId: this.$store.getters.navigatorUserId,
            loggedInStatus: false,
            lastSelectedTreeId: '',
            lastSelectedTreeName: '',
            userDimensions: [],
            selectedUserDimension:'2', //default to standard for now
        	tree: {id:'450867',name:'Siemens Australia',nodes:[],type:'NODE',expandable:true},
            treeShowChildrenArray:[],
        	nodeRetrievedList:[],
            loading: false,
            minimum_interval_time: 900, //minimum interval time is 15 minutes regardless of what it set in Navigator. 
            meterData:[],
            meterDataIdArray: [],
            meterDataIdNameArray:[],                
            localStartTimeStamp: moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            localEndTimeStamp:  moment().startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            selectedTimeRange: 'Last 7 days',
            //utcStartTimeStamp:'10.10.2018 00:00:00',
            //utcEndTimeStamp:'10.01.2019 02:00:00',
        	charts: [],
            legendFontSize: 12,
            legendYPos: 1.3,
            includeRangeSlider: false,
            autoGraphData: true,
            intervalSeconds : 900,
            overrideMeterInterval : false,
            searchString: 'Search in highlighted Node',
            searchFilter: '',
            searchResult:[],
            graphType: "Units",
            graphsHaveDataFlag: false,
            meterDataArrayLock: false,
            consumptionInterval: "7",
            detailedChartIndex: 0,
            nodeRecursiveSearch:true,
            calculatedTable:[],
             tableColumns: [

                {
                    field: 'meterName',
                    label: 'Meter Name',
                    searchable: true,
                    sortable:true,
                    visible:true,
                },
                  {
                    field: 'datasource',
                    label: 'Datasource',
                    searchable: true,
                    sortable:true,
                    visible:false,
                },
                  {
                    field: 'unit',
                    label: 'Unit',
                    searchable: true,
                    sortable:true,
                    visible:false,
                },
                {
                    field: 'readingsCount',
                    label: 'Readings Count',
       
                         sortable:true,
                              visible:true,
                              numeric:true, 
                },
                        {
                    field: 'expectedCount',
                    label: 'Expected Readings Count',
 
                         sortable:true,
                              visible:true,
                              numeric:true, 
                },
                        {
                    field: 'missingDataCount',
                    label: 'Missing Data Count',
        
                         sortable:true,
                              visible:true,
                              numeric:true, 
                },
             
                   {
                    field: 'interpolatedStatus',
                    label: 'Interpolation Status',
        
                         sortable:true,
                              visible:true,
                },
             ]
            
        }
    },
    computed: {

  filteredValidatedTableData(){
            let table = this.calculatedTable;

            table.forEach((meter)=>{
            if (this.excludeOK == true){
                table = table.filter(meter => !meter.tags.includes("OK"))
               
            }
                 if (this.excludeNoData == true){
                 table = table.filter(meter => !meter.tags.includes("No Data"))
            }
             if (this.excludeMissingData == true){
                 table = table.filter(meter => !meter.tags.includes("Missing Data"))
            }
             if (this.excludeNegativeZeros == true){
                 table = table.filter(meter => !meter.tags.includes("Negative/Zero Readings"))
            }
             if (this.excludeSpikes == true){
                 table = table.filter(meter => !meter.tags.includes("Spikes"))
            }
             if (this.excludeDoubles == true){
                 table = table.filter(meter => !meter.tags.includes("Doubles"))
            }
             if (this.excludeZeroConsumption == true){
                 table = table.filter(meter => !meter.tags.includes("Zero Consumption"))
            }

            })
          
            return table
        },
           visibleTableDataOnly(){
//console.log("Visible table exists")
        let jsonToExport = []
        if(this.$refs.dataTable != undefined){
                        let columnsToExport = this.$refs.dataTable.visibleColumns
                        //console.log(columnsToExport)
        let dataTableData = this.$refs.dataTable.visibleData
        //console.log(dataTableData)
        dataTableData.forEach((row)=>{
            rowObject = {}

            columnsToExport.forEach((column)=>{
                rowObject[column.field] = row[column.field]
            })

        jsonToExport.push(rowObject)
        })
        }
        return jsonToExport;

           },

                
            //convert the local timestamps to utc timestamps to be used by Navigator API calls (all in UTC) the data is then later transformed back to local time in the graphs   
            utcStartTimeStamp(){
                return moment(this.localStartTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            utcEndTimeStamp(){
                return moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            searchResultFiltered(){ //search Result Filter whenever new searchResult or searchFilter changes
                let filteredList = [];
                
                //create array of filter terms split by *
                let filterWordsArray = this.searchFilter.split('*');
                
                //If list is nothing, then do nothing
                if(this.searchResult.list == null){
                    return null;
                }else{
                
                //Otherwise get all the meter objects          
                this.searchResult.list.forEach((item)=>{
                    if(item.treeObjectType == 'METER'){
                        filteredList.push(item);
                    }
                });
                
                //for each filter word
                filterWordsArray.forEach((word)=>{
                //update the filteredList to contain only meters with names that include the filter word    
                filteredList = filteredList.filter(item=>item.name.toUpperCase().includes(word.toUpperCase()));
                });
                
                return filteredList;
                }
            },
           
            },
            methods: {
                 calculateTableData(){
                     this.calculatedTable = []
                let table = []
                let chartId = 0;
                let timeDifferenceSeconds = moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss").diff(moment(this.localStartTimeStamp,"DD.MM.YYYY HH:mm:ss"),"seconds")
                this.meterData.forEach((meter)=>{
                let readingsCount = meter.data.length
                let expectedCount =  timeDifferenceSeconds/meter.meterItemDTOs[0].interval
                let missingDataCount = 0

                meter.meter_missing_data_array.forEach((missing_data_object)=>{
                    missingDataCount += missing_data_object.missing_count
                })
                
                let spikesCount = meter.spikesArray.length
                let doublesCount = meter.doublesArray.length
                let negativeOrZeroReadingsCount = meter.negative_or_zero_readings_array.length

              
                let tags = meter.metertags.toString()
                table.push({
                    chartId: chartId,
                    meterId: meter.id,
                    meterName: meter.name,
                    datasource: meter.meterItemDTOs[0].datasource,
                    unit: meter.unit,
                    readingsCount: readingsCount,
                    expectedCount: expectedCount,
                    missingDataCount: missingDataCount,
                    negativeOrZeroReadingsCount: negativeOrZeroReadingsCount,
                    spikesCount: spikesCount,
                    doublesCount: doublesCount,
                    tags: tags,
                    sum: meter.sum,
                    average:meter.average,
                    min: meter.min,
                    max: meter.max,
                    differenceFromFirstToLastReading:meter.differenceFromFirstToLastReading,
                    interpolatedStatus: meter.interpolatedStatus
                })
                chartId +=1; 
                })
                //console.log("Caluclated Table:")
                //console.log(table)
                this.calculatedTable = table;
            },

        validateMeterData(){
            //missing data, negative/zero consumption, //doubles // spikes, //all zero
            this.meterData.forEach((meter)=>{
                meter.metertags = []
    let allZeroFlag = true;
    let noDataFlag = false;
    let missingDataFlag = false;
    let negative_or_zeroFlag = false; 
    let negative_or_zero_readings_array = []
    let meter_missing_data_array = []
    let timeMissingDifferenceSeconds = 0
    let spikes_moving_average = 1;
    let spikesFlag = false;
    let spikesArray = []
    let doublesFlag = false;
    let doublesArray = [];
    let double_reading_n_minus_ = 9999999999
    let double_reading_n_minus_3 = 9999999999
    let double_reading_n_minus_2 = 9999999999
    let double_reading_n_minus_1 = 9999999999
    let readingsDifferenceFromFirstToLastValue = 0.0
    let sumTotal = 0.0
    let average = 0.0
    let min = 0.0
    let max = 0.0

    if (meter.data.length == 0){
    noDataFlag = true;
    allZeroFlag =false;
    }

//if all consumption readings are null, also considered no data
    if (meter.data.filter(x => x.value != null).slice(-1)[0] == undefined){
      noDataFlag = true;
    allZeroFlag =false;   
    }

    if (noDataFlag == false){

//calculate sum/max/min/average






    let lastMissingTimestamp = moment(this.localStartTimeStamp,"DD.MM.YYYY HH:mm:ss")
    let lastMissingValue = null

 //no consumptoin calculation
        let lastNonNullValue = meter.data.filter(x => x.value != null).slice(-1)[0].value;

        if (this.NavigatorDataType == "Readings" && meter.data[0].value !=  lastNonNullValue){
              allZeroFlag = false;
        }

        meter.data.forEach((reading,index)=>{
                //only calculate if value is not null
                if (reading.value !=null){
                        sumTotal += reading.value
                        if (reading.value > max){
                            max = reading.value
                        }
                        if (reading.value < min){
                        min = reading.value
                        }

            //no consumptoin calculation
            if (this.NavigatorDataType == "Consumption"){
            if (reading.value != 0.0){
                allZeroFlag = false;
            }
            }
         //, negative/zero consumption
         if (reading.value < 0 || (reading.value == 0 && this.NavigatorDataType == "Readings" )){
        negative_or_zero_readings_array.push(reading)
        negative_or_zeroFlag = true
         }
        
        //missing data
    
     
          
             timeMissingDifferenceSeconds = reading.momentLocalTime.diff(lastMissingTimestamp,"seconds")
            if (timeMissingDifferenceSeconds > (meter.meterItemDTOs[0].interval * 1.5)){
                missingDataFlag = true;
                let missing_readings_count = Math.max(Math.floor((timeMissingDifferenceSeconds - meter.meterItemDTOs[0].interval)/meter.meterItemDTOs[0].interval),0);
                meter_missing_data_array.push({"missing_start_time": lastMissingTimestamp, "missing_end_time": reading.momentLocalTime, "missing_start_value": lastMissingValue, "missing_end_value": reading.value, "missing_count": missing_readings_count})
            }

            lastMissingTimestamp = reading.momentLocalTime
            lastMissingValue = reading.value
        


        //Spike Readings!
        
            //calculating moving average
            let beginIndex = Math.min(index - this.spikeMovingAverageWindowLength,0)
            let endIndex = Math.max(index+this.spikeMovingAverageWindowLength,meter.data.length)
            let sliced_data_array = meter.data.slice(beginIndex,endIndex)
            let sliced_data_array_total = 0
            let sliced_data_array_count = 0
            sliced_data_array.forEach((record)=>{
                if (record.value != null){
                sliced_data_array_total += record.value
                sliced_data_array_count += 1
                }
            })
            spikes_moving_average = sliced_data_array_total/sliced_data_array_count;

            if (reading.value > Math.max(spikes_moving_average,this.movingAverageMinimum) * this.spikesMultiplicativeThreshold)
            {
                spikesArray.push(reading)
                spikesFlag = true;
            }
        


            //Double Reading. If previous is zero and current is roughly double of one before previous
      
            //calculating moving average
            if (this.NavigatorDataType == "Consumption" && double_reading_n_minus_1 == 0 || this.NavigatorDataType == "Readings" && ((double_reading_n_minus_1 - double_reading_n_minus_2) == 0)){
                if (reading.value > (double_reading_n_minus_2 * (2-this.doublesLeniencyThresholdPercent/100)) &&  reading.value < (double_reading_n_minus_2 * (2+this.doublesLeniencyThresholdPercent/100))){
                     if (reading.value > (double_reading_n_minus_3 * (2-this.doublesLeniencyThresholdPercent/100)) &&  reading.value < (double_reading_n_minus_3 * (2+this.doublesLeniencyThresholdPercent/100))){
                           doublesArray.push(reading)
                doublesFlag = true;
                     }
                }
            }

        double_reading_n_minus_1  = reading.value
           double_reading_n_minus_2 = double_reading_n_minus_1
           double_reading_n_minus_3 = double_reading_n_minus_2


        }

        


        }); //end of forEach meter reading


//missing data for end time
     timeMissingDifferenceSeconds = moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss").diff(lastMissingTimestamp,"seconds")
            if (timeMissingDifferenceSeconds > (meter.meterItemDTOs[0].interval * 1.5)){
                //console.log("Misisng Data")
                let missing_readings_count = Math.max(Math.floor((timeMissingDifferenceSeconds - meter.meterItemDTOs[0].interval)/meter.meterItemDTOs[0].interval),0);
                meter_missing_data_array.push({"missing_start_time": lastMissingTimestamp, "missing_end_time": moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss"), "missing_start_value": lastMissingValue, "missing_end_value": null, "missing_count": missing_readings_count})
            }


            readingsDifferenceFromFirstToLastValue = lastNonNullValue - meter.data[0].value
average = sumTotal/meter.data.length
    }// end of if there is data for each meter

meter.meter_missing_data_array = (meter_missing_data_array)

let missing_data_to_interpolate_array = []
meter_missing_data_array.forEach((missingRange)=>{
    let missing_data_to_interpolate = []
    if (missingRange.missing_start_value != null && missingRange.missing_end_value != null){
     
        let timedifference = missingRange.missing_end_time.diff(missingRange.missing_start_time,"seconds")

        let missingInterval = meter.meterItemDTOs[0].interval
        if (this.overrideMeterInterval){
            missingInterval = this.intervalSeconds
        }
        let missing_readings_count = Math.max(Math.floor((timedifference - missingInterval)/missingInterval),0);
        
        let interpolation_gradient = (missingRange.missing_end_value - missingRange.missing_start_value)/timedifference
        let interpolation_start_value = missingRange.missing_start_value
        let interpolation_start_time = missingRange.missing_start_time

      for (let z = 0; z < missing_readings_count; z++){
           let interpolatedTimeStampMoment = interpolation_start_time.toDate()
           interpolatedTimeStampMoment.setSeconds(interpolatedTimeStampMoment.getSeconds() + ((z+1)*missingInterval));
           let interpolatedtimediff = moment(interpolatedTimeStampMoment).utc().diff(missingRange.missing_start_time.local(),'seconds')

            let interpolatedTimeValue = interpolation_start_value + interpolation_gradient*interpolatedtimediff
            missing_data_to_interpolate.push({"interpolatedTimeStampMoment": moment(interpolatedTimeStampMoment), "interpolatedTimeValue": interpolatedTimeValue})
        } 
  
          
    }
    
    missing_data_to_interpolate_array.push(missing_data_to_interpolate)
})

meter.missing_data_to_interpolate_array=missing_data_to_interpolate_array
meter.spikesArray = spikesArray
meter.negative_or_zero_readings_array = negative_or_zero_readings_array
meter.doublesArray = doublesArray
meter.differenceFromFirstToLastReading = parseFloat(readingsDifferenceFromFirstToLastValue.toFixed(2))
meter.sum = parseFloat(sumTotal.toFixed(2))
meter.average = parseFloat(average.toFixed(2))
meter.min = parseFloat(min.toFixed(2))
meter.max = parseFloat(max.toFixed(2))

//clear up memory
    negative_or_zero_readings_array = null
     meter_missing_data_array =null
timeMissingDifferenceSeconds = null
  spikes_moving_average = null
     spikesArray = null
    doublesArray = null
     sumTotal = null
average = null
 min = null
max = null
readingsDifferenceFromFirstToLastValue=null


if (noDataFlag == true){
       meter.metertags.push("No Data") 
}
if (allZeroFlag == true){
    meter.metertags.push("Zero Consumption")
}
if (negative_or_zeroFlag == true){
    meter.metertags.push("Negative/Zero Readings")
}

if (missingDataFlag == true){
    meter.metertags.push("Missing Data")
}

if (spikesFlag == true){
    meter.metertags.push("Spikes")
}
if (doublesFlag == true){
    meter.metertags.push("Doubles")
}


if (meter.metertags.length == 0 ){
    meter.metertags.push("OK")
}

            });
            return //console.log("Validated Table")
        },
            	
        //Updates Current Time Method
        updateCurrentTime() {
        	this.currentTime = moment().format('LTS')
        },
        
        changeTitle() {
        	this.charts[0].layout.title='changed';
        },
        
        //Add data to graph
        addData: function() {
        },

        detailedRowFunction(row,index){
            this.graphSingleMeterData(this.meterData.find(x=>x.id == row.meterId));
//console.log(row)
//console.log(index)
        },
        
        //loginto Navigator check and get userId
        loginNavigator(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/current"
             
             //return for the async await
              return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                
                this.userId = response.data.id;
                this.loggedInStatus = true;
                 this.loading=false;
                 
               }).catch(error => {
                        //console.log(error)
                        this.loggedInStatus = false;
                        this.loading=false;

                }); 
        },
        getUserDimensions(){
            this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/" + this.userId.toString() + "/dimensions";
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                response.data.forEach((dimension)=>{
                this.userDimensions.push({id: dimension.id, name: dimension.name});
                });
                 this.loading=false;
                 
               }).catch(error => {
                        //console.log(error)
                        this.loading=false;
                });
                
        },
        //update metertree root with user selected dimension
        updateMeterTreeRoot(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/dimension/" + this.selectedUserDimension.toString() + '/root';
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {

                //base node of tree equals the response data
                this.$store.commit('changetree',{id: response.data.id, name: response.data.name, nodes: [], type:response.data.treeObjectType, expandable: response.data.expandable });
                this.$store.commit('changelastSelectedTreeId',response.data.id);
                this.$store.commit('changelastSelectedTreeName',response.data.name);
                //empty node retreived list
                this.$store.commit('changenodeRetrievedList',[]);
                this.$store.commit('changetreeShowChildrenArray',[]); //empty tree as well
                 this.loading=false;
                 
               }).catch(error => {
                        //console.log(error)
                        this.loading=false;
                });
                
        },
        
        //initial load method, with async methods so each function waits for the previous one to finish
        async initialLoad() {
              await this.loginNavigator();
              await this.getUserDimensions();
              await this.updateMeterTreeRoot();
              this.$refs.tree.getChildrenNodes(this.$store.getters.lastSelectedTreeId)

        },
        
        //search Navigator for meters/nodes with the last selected Node
        searchNavigator() {

             this.loading=true;
            //Navigator devices API url
            const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.$store.getters.navigatorUserId.toString() +"/node/" + this.$store.getters.lastSelectedTreeId.toString() + "/search?searchstring=" + this.searchString.toString();

            this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},
            }).then(response => {
                
            	this.searchResult = response.data;
                 this.loading=false;
        }).catch(error => { 
        this.loading=false;
                        //console.log(error)             
                        });  
        
        },
        getIntialNodes(meterId){
        	
        	this.showChildren = !this.showChildren;
            //Navigator devices API url
            //requires userId, starttime and endtime in unix (with milliseconds)
            //using CORS proxy to bypass the No Access-Control-Allow-Origin header in server
            //see https://gist.github.com/jesperorb/6ca596217c8dfba237744966c2b5ab1e for more details on how to handle CORs client-side
            let url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/node/" + meterId + "/children";              
            
            this.$axios({ method: 'get',
            	url: url,
            	headers: {
            		'Accept': 'application/json',
            		'Content-Type': 'x-www-form-urlencoded',
            	},
     
            }).then(response => {                
            //set this Vue instance devices data with the formatted reponse data
            
            let step;
            //iterate through whole data array
            for (step = 0; step < response.data.length; step++) {
            	this.tree.nodes.push({name:response.data[step].name, id:response.data[step].id, nodes:[]});
            	
            }
        })
        },
        addSearchMeters(){

                 let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
            this.searchResultFiltered.forEach((meter)=>{
       
                if(meterDataIdArray.includes(meter.id.split('-')[1]) === false){    //check if meter is not already in the meter data id array 
            meterDataIdArray.push(meter.id.split('-')[1]);
            meterDataIdNameArray.push({id: meter.id.split('-')[1], name: meter.name, loaded:false, unit: ''} );
            
                }
            });
            this.$store.commit('changemeterDataIdArray',meterDataIdArray);
            this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArray);    
                
        },
        clearMeters(){
            this.$store.commit('changemeterDataIdArray',[]);
            this.$store.commit('changemeterDataIdNameArray',[]);
        },
        
        setDates(range){
            
            if(range.toUpperCase() === "LAST 24 HOURS"){
               this.localStartTimeStamp = moment().subtract(1, "days").format("DD.MM.YYYY HH:mm:ss");
               this.localEndTimeStamp = moment().format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "YESTERDAY"){
                this.localStartTimeStamp = moment().subtract(1,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 7 DAYS"){
                 this.localStartTimeStamp = moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "LAST 14 DAYS"){
                 this.localStartTimeStamp = moment().subtract(14,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }             
            else if(range.toUpperCase() === "LAST 30 DAYS"){
                this.localStartTimeStamp = moment().subtract(30,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 3 MONTHS"){  
                this.localStartTimeStamp = moment().subtract(3,'months').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");               
            } 
            else if(range.toUpperCase() === "LAST YEAR"){
                this.localStartTimeStamp = moment().subtract(1,'years').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
            }
            else if(range.toUpperCase() === "YEAR TO DATE"){
                this.localStartTimeStamp = moment().startOf('year').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
               
            }
        },

        regraphData(){
                //this.graphSeparateMeterData()
        
    
        },

async searchNodesAndAddMetersButton(){
this.searchNodesAndAddMeters(this.$store.getters.lastSelectedTreeId)
},

        async searchNodesAndAddMeters(nodeId){
         console.log("searching node for meters " + nodeId)
            this.loading = true;
    //console.log("Getting children for node: "+nodeId)
    let url = "https://eadvantage.siemens.com/remote/release/tree/user/"+this.userId+"/node/"+nodeId+"/children/"

await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
                        }).then(async (response) => {   
    response.data.forEach((item)=>{
        if (item["treeObjectType"] == "METER"){
            let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
             meterDataIdArray.push(item["id"].split("-")[1]); //expecting formaat of NodeId_-meterId
                  meterDataIdNameArray.push({id: item["id"].split("-")[1], name: item.name, loaded:false, unit: ''}); 
                  this.$store.commit('changemeterDataIdArray', meterDataIdArray);
                  this.$store.commit('changemeterDataIdNameArray', meterDataIdNameArray);
        }
    })

    if(this.nodeRecursiveSearch == true){
        let nodeIdsArray = []
       for(let i = 0; i<response.data.length; i++){
        if (response.data[i]["treeObjectType"] == "NODE"){
            nodeIdsArray.push(response.data[i]["id"])
            
        }
       }
       await this.searchNodesArrayAndAddMeters(nodeIdsArray)
    }
 
                        }).catch((error) => {
                    console.log(error)
              
                });
  this.loading = false;
    return;
 

                        
        },


async searchNodesArrayAndAddMeters(nodeIdsArray){
                console.log("searching node for meters " + nodeIdsArray)
                 let newNodeIdsArray = []

 for (let i = 0; i< nodeIdsArray.length/this.concurrent_requests_limit; i++){
    await Promise.all(nodeIdsArray.slice(0+i*this.concurrent_requests_limit,(i+1)*this.concurrent_requests_limit).map(async (nodeId, index)  => {
            this.loading = true;
    let url = "https://eadvantage.siemens.com/remote/release/tree/user/"+this.userId+"/node/"+nodeId+"/children/"
                        await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
                        }).then(async (response) => { 
                              response.data.forEach((item)=>{
        if (item["treeObjectType"] == "METER"){
            let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
             meterDataIdArray.push(item["id"].split("-")[1]); //expecting formaat of NodeId_-meterId
                  meterDataIdNameArray.push({id: item["id"].split("-")[1], name: item.name, loaded:false, unit: ''}); 
                  this.$store.commit('changemeterDataIdArray', meterDataIdArray);
                  this.$store.commit('changemeterDataIdNameArray', meterDataIdNameArray);
        }
    })

    if(this.nodeRecursiveSearch == true){
       
       for(let i = 0; i<response.data.length; i++){
        if (response.data[i]["treeObjectType"] == "NODE"){
            newNodeIdsArray.push(response.data[i]["id"])
        }
       }
      
    }

                        }).catch((error) => {
                    console.log(error)
                   
                });  
                      
                        

            }))
                        
        }
          await this.searchNodesArrayAndAddMeters(newNodeIdsArray)
          newNodeIdsArray=null
              this.loading = false;
          return

},


closeAllDetailedRows(){
this.$refs.dataTable.data.forEach(row=>{
 this.$refs.dataTable.closeDetailRow(row)
})
},

async interpolateAllMeters()
{
for (let i=0; i<this.$refs.dataTable.data.length; i++){
    let row = this.$refs.dataTable.data[i]
    console.log(row)
    console.log(row.meterId)
    await this.postReadingstoNavigator(row,row.meterId)  //remove awiat if you want them to do all meters at once
}
},

async postReadingstoNavigator(row,meterId){
let meter = this.meterData.find(x=> x.id == meterId)
let readings_array = meter.missing_data_to_interpolate_array
console.log(meter)
let body = []
readings_array.forEach((readings)=>{
readings.forEach((reading)=>{
  body.push({
    "comment": "",
    "correctionValue": "0.0",
    "qualityAttribute": "512", //estimated value
    "utcOrgRectime": reading.interpolatedTimeStampMoment.utc().format('M/D/YYYY hh:mm:ss A'),
    "utcRectime": reading.interpolatedTimeStampMoment.utc('M/D/YYYY hh:mm:ss A'),
    "value": reading.interpolatedTimeValue
  })
})
})

console.log(body)
this.loading= true
await this.$axios({
                    method: 'post',
                    url: this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/"+meter.id+"/readings",
                    data: body,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },

                }).then((response) => {
                    console.log("Readings added successfully")
                    this.loading=false;
                    meter.interpolatedStatus = response.statusText
                    this.calculateTableData() //update status
                    this.$refs.dataTable.closeDetailRow(row)
    
                })
                .catch((error) => {
                    console.log(error)
                    this.loading=false;
                    meter.interpolatedStatus = error.statusText
                    this.calculateTableData() //update status
    
                });


},

          async getAsyncMeterData(){
            this.closeAllDetailedRows()
            //reset the loaded meter data flags  
            let meterDataIdNameArrayUnloaded =  this.$store.getters.meterDataIdNameArray
            meterDataIdNameArrayUnloaded.forEach((meter)=>{
               meter.loaded = false;
            });                
            this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArrayUnloaded);
              
            this.meterData = []; //reset the meterData stored
            this.loading = true; //set loading flag 
            
            //intialise variables.
         
     
       

            //GET the meter Data using the meter ID. Then do a get request for meter reading with start and time to get reading count,
            //generate all the necessary urls because each response from a get request is limited to only 1000 readings, 
            //do all the get requests simultaneously to get all the readings, then push them into the data array. 
            
            
            let meterIDsArray = this.$store.getters.meterDataIdArray.toString().split(','); //turn the string of meterIds into an array. 
            //for (index = 0; index < meterIDsArray.length; index++){   //async call inside for loop doesn't work well, index always last value


            if (this.NavigatorDataType == "Readings"){
                   
 let meterStructureLength = meterIDsArray.length;
  let concurrent_requests = this.concurrent_requests_limit;  //number of concurrent requests to sent at a time
    
    //get all urls to delete readings, but do it in batches
    
    for (let i = 0; i< meterStructureLength/concurrent_requests; i++){
             await Promise.all(meterIDsArray.slice(0+i*concurrent_requests,(i+1)*concurrent_requests).map(async (meter, index)  => {
   let meterDataTemplate
                    
                        let meterInfoUrl =  this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString();  
                        
                        await this.$axios({ method: 'get',url: meterInfoUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
                        }).then(async response => {   
                        
 
                        response.data["data"]=[];
                        //this.meterData.push(response.data);
                        
                        
                       //THIS meter data template is going to be filled with the meter data, passing down through each of the axios promises
                        //then finally pushed to the this.meterData array. This is to stop race conditions when pushing the data straight into the this.meterDAta array 
                        //and trying to use index to put the data in the right place with all the async calls going on. Seems to be working well
                        let meterDataTemplate = response.data;


     //set minimum interval time for calculations later in validation
                        meterDataTemplate.meterItemDTOs[0].interval = Math.max(meterDataTemplate.meterItemDTOs[0].interval, this.minimum_interval_time)
 

                        let meterReadingsUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                        
                        //variables can be passed into the next promise .then by using a promise.all and a array
                        return await Promise.all([this.$axios({ method: 'get',url: meterReadingsUrl,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}), meterDataTemplate]);
                        
                        }).then(async([response2, meterDataTemplate]) => {
                         
                        let readingPagesTotal = Math.ceil((parseInt(response2.data.totalCount)/1000)); //divide and round up
                        //console.log("Total pages to retrieve: " + readingPagesTotal);
    

                               
                                  //construct array of urls
                        let urlArray = [];
   
                        let meterReadingMultipleUrl = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/" + meter.toString() +'/readings?utcStartTimestamp='+this.utcStartTimeStamp.toString() + '&utcEndTimestamp=' + this.utcEndTimeStamp.toString(); 
                          for (let pageNumber = 0; pageNumber < readingPagesTotal; pageNumber++){
                            urlArray.push(meterReadingMultipleUrl+"&limit=1000&start=" + (pageNumber*1000).toString());
  
                          }
                          
                           
                    let promiseArray = urlArray.map(url => this.$axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
                            promiseArray.push(meterDataTemplate);
                           //do all get request at same time for efficiency
                            return await this.$axios.all(promiseArray);   
                               
                        }).then(async(response3) => {
                 
                        meterDataTemplate = response3.pop();
                        meterDataTemplate.interpolatedStatus = "Not Started"
                        
                        //check if response 3 is empty (means no data exists for meter)
                        if(response3.length === 0){ 
                        meterDataTemplate.unit = "No Data"; //push one reading with a no data unit for graphs to display
                        }
                        else{
                        meterDataTemplate.unit= this.$store.getters.units.find(element => element.id == meterDataTemplate.meterItemDTOs[0].unit).unit;
                        }
        
                        
                                 //push all meter readings into the meterData[index].data array
                                 response3.forEach((pageResponse, pageIndex)=>{
                                     pageResponse.data.items.forEach((reading, readingIndex)=>{
                                        //this.meterData[index].data.push(reading);
                                       meterDataTemplate.data.push(reading);
                                     });
                                 });
                             
                        //standardise time to local
                        meterDataTemplate.data.forEach((reading)=>{
                            reading.momentLocalTime = moment.utc(reading.utcRectime).local()
                        }) 
                             //push the meter Data in the meterData template to the this.meterData (we don't care the order of the meters so we don't worry about race conditions)    
                     
                                  this.meterData.length =+ this.meterData.length 
                             this.meterData[this.meterData.length] = meterDataTemplate;
                            
                            //console.log(meterDataTemplate);
                            
                            return await Promise.all([meterDataTemplate]);
                        }).then(async (response4)=>{
                                      //console.log(response4);
                          //response4[0] is meterDataTempalte
                          let meterDataIdNameArrayUpdate = this.$store.getters.meterDataIdNameArray;
                                let index = meterDataIdNameArrayUpdate.findIndex(x => x.id==response4[0].id);
                             if (response4[0].unit == "No Data"){
                                   meterDataIdNameArrayUpdate[index].unit = "No Data";
                             }else{
                          meterDataIdNameArrayUpdate[index].unit = this.$store.getters.units.find(element => element.id == response4[0].meterItemDTOs[0].unit).unit;
                            }
    
                          meterDataIdNameArrayUpdate[index].loaded = true;
                          
                          this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArrayUpdate);
                          //console.log("Finished Loading Meter: " + response4[0].name);
                               response4=null
                          meterDataTemplate = null
                          return Promise.resolve('ok') ;
                          
                        
                        }).catch(error => { 
                        console.log(error)             
                        });    
            })

            );  
         }  
            this.loading=false;
            
            return
            }
        },   
        
        //Method to get Meter Data and then after all the meter data is saved then graph if the autoGraphData checkbox is true
        async getMeterDataButton(){
            //console.log("Time to get Data!");
            await this.getAsyncMeterData();
            await this.validateMeterData()
            await this.calculateTableData();
            //console.log("Time to Graph!");
            if(this.autoGraphData === true){
                //this.graphSeparateMeterData();
            }    
            this.graphsHaveDataFlag = true
            this.loading = false;
        
        },

        async revalidateAndReGraphData(){
            console.log("Revalidating Data")
               await this.validateMeterData()
            await this.calculateTableData();
        },
              
 
        
     
        graphSeparateMeterData(){
            this.loading = true;
            //Variation 2 is to split graphs by units
            //empty the charts data field
            let chartsGraphData=[];
            let chartTraces = [];
            let unitsArray = [];
            let chartCounter = 0;
            let chartLayout = {};
            
            let legendLayout = {};
            this.meterData.forEach((meter,index)=>{
                let chartUnit = meter.unit;
              
                
                let chartUuid = 'chart'+index.toString(); //if trying to change div without an existing div then will throw null error for DOM
                
                let chartlayout = {};
                let chartTitle = '';
                let xaxisTitle = '';
                let yaxisTitle = '';
                  let xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                let xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                
                 let xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle,tickfont: {size:this.legendFontSize}, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                 legendLayout = {font:{size:this.legendFontSize},orientation: 'h',xanchor:"center", y:this.legendYPos-0.2, x:0.5}    
                } else {xaxisLayout = {title: xaxisTitle,tickfont: {size:this.legendFontSize}, range: [xaxisRangeMin, xaxisRangeMax]};
                legendLayout = {font:{size:this.legendFontSize},orientation: 'h',xanchor:"center", y:this.legendYPos-0.2, x:0.5}
                }
                

//Shapes
let shapes = []

//missing data shapes
meter.meter_missing_data_array.forEach((missing_data_object)=>{
    shapes.push({
            type: 'rect',
            // x-reference is assigned to the x-values
            xref: 'x',
            // y-reference is assigned to the plot paper [0,1]
            yref: 'paper',
            x0: missing_data_object.missing_start_time.toDate(),
            y0: 0,
            x1: missing_data_object.missing_end_time.toDate(),
            y1: 1,
            fillcolor: '#d3d3d3',
            opacity: 0.4,
            line: {
                width: 0
            }
    })
})


                
                chartLayout = {shapes: shapes, title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle,tickfont: {size:this.legendFontSize}}, legend: legendLayout, showlegend: true};

                let chartTraceName = meter.name + " ("+meter.unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
                 
                        chartTraceXArray.push(reading.momentLocalTime.toDate());
                
                });
                 
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);      
                    
                });

                               //if empty then change array to null so it shows up on graph
        if (chartTraceXArray.length == 0){
chartTraceXArray = [null]
        }
        if (chartTraceYArray.length == 0){
chartTraceYArray = [null]
        }

                let chartLineColour = '#17BECF'
                let chartTrace = {type: "scattergl", mode: "lines+markers",  marker:{size:2}, name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                let traces = [chartTrace]
        

//negative/zero data markers
if (meter.negative_or_zero_readings_array.length > 0){
let negative_or_zero_readings_array_x_trace = []
let negative_or_zero_readings_array_y_trace = []

meter.negative_or_zero_readings_array.forEach((reading)=>{
    negative_or_zero_readings_array_x_trace.push(reading.momentLocalTime.toDate())
    negative_or_zero_readings_array_y_trace.push(reading.value)
})
         traces.push({
  x: negative_or_zero_readings_array_x_trace,
  y: negative_or_zero_readings_array_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255, 0, 0,0.5)',
    size: 5,
    line: {
      color: 'rgb(255, 0, 0)',
      width: 2
    }
  },
  name: 'Negative/Zero Readings'
  })

}



//Spikes markers
if (meter.spikesArray.length > 0){
let spikesArray_x_trace = []
let spikesArray_y_trace = []

meter.spikesArray.forEach((reading)=>{
    spikesArray_x_trace.push(reading.momentLocalTime.toDate())
    spikesArray_y_trace.push(reading.value)
})
         traces.push({
  x: spikesArray_x_trace,
  y: spikesArray_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255, 153, 0,0.5)',
    size: 5,
    line: {
      color: 'rgb(255, 153, 0)',
      width: 2
    }
  },
  name: 'Spikes'
  })

}

//Doubles markers
if (meter.doublesArray.length > 0){
let doublesArray_x_trace = []
let doublesArray_y_trace = []

meter.doublesArray.forEach((reading)=>{
    doublesArray_x_trace.push(reading.momentLocalTime.toDate())
    doublesArray_y_trace.push(reading.value)
})
         traces.push({
  x: doublesArray_x_trace,
  y: doublesArray_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255,0,205,0.5)',
    size: 5,
    line: {
      color: 'rgb(255,0,205,)',
      width: 2
    }
  },
  name: 'Doubles'
  })

}

                //push the chart data tract into the graph
            chartsGraphData.push({uuid: chartUuid, traces: traces, layout: chartLayout})   
            });
 
            this.charts = chartsGraphData;
            chartsGraphData = null;
            //console.log(chartsGraphData);  
            this.loading = false;   

               this.graphType = "SeperateCharts"  
            this.meterDataArrayLock = false          
        },


 graphSingleMeterData(meter){
            this.loading = true;
            //Variation 2 is to split graphs by units
            //empty the charts data field
            let chartsGraphData=[];
            let chartTraces = [];
            let unitsArray = [];
            let chartCounter = 0;
            let chartLayout = {};
            
            let legendLayout = {};
         
                let chartUnit = meter.unit;
              
                
                let chartUuid = 'chart'+meter.id.toString(); //if trying to change div without an existing div then will throw null error for DOM
                
                let chartlayout = {};
                let chartTitle = '';
                let xaxisTitle = '';
                let yaxisTitle = '';
                  let xaxisRangeMin = moment.utc(this.utcStartTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                let xaxisRangeMax = moment.utc(this.utcEndTimeStamp,"DD.MM.YYYY HH:mm:ss").local().toDate();
                
                 let xaxisLayout;
                if (this.includeRangeSlider === true){
                xaxisLayout = {title: xaxisTitle,tickfont: {size:this.legendFontSize}, range: [xaxisRangeMin, xaxisRangeMax], rangeselector: {buttons: [
                    { count: 1,label: '1d',step: 'day',stepmode: 'backward'},
                    { count: 7,label: '1w',step: 'day',stepmode: 'backward'},
                    { count: 1,label: '1m',step: 'month',stepmode: 'backward'},
                    { count: 6,label: '6m',step: 'month',stepmode: 'backward'},
                    {step: 'all'}
                        ]},
                    rangeslider: {autorange: true, visible:true},
                    }
                 legendLayout = {font:{size:this.legendFontSize},orientation: 'h',xanchor:"center", y:this.legendYPos-0.2, x:0.5}    
                } else {xaxisLayout = {title: xaxisTitle,tickfont: {size:this.legendFontSize}, range: [xaxisRangeMin, xaxisRangeMax]};
                legendLayout = {font:{size:this.legendFontSize},orientation: 'h',xanchor:"center", y:this.legendYPos-0.2, x:0.5}
                }
                

//Shapes
let shapes = []

//missing data shapes
meter.meter_missing_data_array.forEach((missing_data_object)=>{
    shapes.push({
            type: 'rect',
            // x-reference is assigned to the x-values
            xref: 'x',
            // y-reference is assigned to the plot paper [0,1]
            yref: 'paper',
            x0: missing_data_object.missing_start_time.toDate(),
            y0: 0,
            x1: missing_data_object.missing_end_time.toDate(),
            y1: 1,
            fillcolor: '#d3d3d3',
            opacity: 0.4,
            line: {
                width: 0
            }
    })
})


                
                chartLayout = {shapes: shapes, title: chartTitle, xaxis: xaxisLayout, yaxis: {title:yaxisTitle,tickfont: {size:this.legendFontSize}}, legend: legendLayout, showlegend: true};

                let chartTraceName = meter.name + " ("+meter.unit+")";
                
                let chartTraceXArray = [];
                meter.data.forEach((reading)=>{
                    //convert into local browser time from UTC before putting into X array
                    //original utc format in 11/3/2018 03:30:00 PM
                    //let utcDateTime = moment(reading).format('M/D/YYYY hh:MM:SS a');
                 
                        chartTraceXArray.push(reading.momentLocalTime.toDate());
                
                });
                 
                let chartTraceYArray = [];
                    meter.data.forEach((reading)=>{
                    chartTraceYArray.push(reading.value);      
                    
                });

                               //if empty then change array to null so it shows up on graph
        if (chartTraceXArray.length == 0){
chartTraceXArray = [null]
        }
        if (chartTraceYArray.length == 0){
chartTraceYArray = [null]
        }

                let chartLineColour = '#17BECF'
                let chartTrace = {type: "scattergl", mode: "lines+markers",  marker:{size:2}, name: chartTraceName, x: chartTraceXArray, y: chartTraceYArray};
                //line: {color: '#17BECF'}
                
                let traces = [chartTrace]
        

//Interpolated Data
if (meter.missing_data_to_interpolate_array.length > 0){
let ia_x_trace = []
let ia_y_trace = []

meter.missing_data_to_interpolate_array.forEach((interpolation_array)=>{
    interpolation_array.forEach((interpolation_reading)=>{
    ia_x_trace.push(interpolation_reading.interpolatedTimeStampMoment.toDate())
    ia_y_trace.push(interpolation_reading.interpolatedTimeValue)
    })
})
         traces.push({
  x: ia_x_trace,
  y: ia_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255, 255, 0,0.5)',
    size: 2,
    line: {
      color: 'rgb(255, 255, 0)',
      width: 2
    }
  },
  name: 'Interpolated Values'
  })

}


//negative/zero data markers
if (meter.negative_or_zero_readings_array.length > 0){
let negative_or_zero_readings_array_x_trace = []
let negative_or_zero_readings_array_y_trace = []

meter.negative_or_zero_readings_array.forEach((reading)=>{
    negative_or_zero_readings_array_x_trace.push(reading.momentLocalTime.toDate())
    negative_or_zero_readings_array_y_trace.push(reading.value)
})
         traces.push({
  x: negative_or_zero_readings_array_x_trace,
  y: negative_or_zero_readings_array_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255, 0, 0,0.5)',
    size: 5,
    line: {
      color: 'rgb(255, 0, 0)',
      width: 2
    }
  },
  name: 'Negative/Zero Readings'
  })

}



//Spikes markers
if (meter.spikesArray.length > 0){
let spikesArray_x_trace = []
let spikesArray_y_trace = []

meter.spikesArray.forEach((reading)=>{
    spikesArray_x_trace.push(reading.momentLocalTime.toDate())
    spikesArray_y_trace.push(reading.value)
})
         traces.push({
  x: spikesArray_x_trace,
  y: spikesArray_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255, 153, 0,0.5)',
    size: 5,
    line: {
      color: 'rgb(255, 153, 0)',
      width: 2
    }
  },
  name: 'Spikes'
  })

}

//Doubles markers
if (meter.doublesArray.length > 0){
let doublesArray_x_trace = []
let doublesArray_y_trace = []

meter.doublesArray.forEach((reading)=>{
    doublesArray_x_trace.push(reading.momentLocalTime.toDate())
    doublesArray_y_trace.push(reading.value)
})
         traces.push({
  x: doublesArray_x_trace,
  y: doublesArray_y_trace,
  type: 'scattergl',
  mode: 'markers',
  marker: {
    color: 'rgb(255,0,205,0.5)',
    size: 5,
    line: {
      color: 'rgb(255,0,205,)',
      width: 2
    }
  },
  name: 'Doubles'
  })

}

                //push the chart data tract into the graph
            chartsGraphData.push({uuid: chartUuid, traces: traces, layout: chartLayout})   
        
 
            this.singleChartData = chartsGraphData;
            chartsGraphData = null;
            //console.log(chartsGraphData);  
            this.loading = false;   

               this.graphType = "SeperateCharts"  
            this.meterDataArrayLock = false          
        },


        //if there is an event for a graph to update its range, will update all graphs ranges. 
        relayout_graphs(payload){
            if (this.resizeAllGraphs == true){
            ////console.log("changing layout ranges")
            ////console.log(payload)
            this.charts.forEach(chart => {
                if ( "xaxis.autorange" in payload) {
                   
                    chart.layout.xaxis.autorange = true
                }
                else if ("xaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                       chart.layout.xaxis.range = [payload["xaxis.range[0]"],payload["xaxis.range[1]"]]
                }

                     if ( "yaxis.autorange" in payload) {
                   
                    chart.layout.yaxis.autorange = true
                }
                else if ("yaxis.range[0]" in payload){
                      chart.layout.xaxis.autorange = false
                     chart.layout.yaxis.range = [payload["yaxis.range[0]"],payload["yaxis.range[1]"]]
                }
            
                ////console.log(chart.layout)
            });

            }

        },
        


        //Save all the data in the this.meterData into a CSV
        saveDataAsCSV(){
            this.loading=true;   
            //console.log("Time to save meter data to a CSV!");
            
            let csvData =''; 
            let separator = ',';
            let newline = '\n';
            let BOM = "\uFEFF";
            let rowHeaderArray = [];
            let maxlength = 0;
            let step = 0;
            let rowArray = [];
            
            //Get headers
            this.meterData.forEach((meter)=>{
                rowHeaderArray.push("DateTime "+meter.name+ " " + meter.unit);
                rowHeaderArray.push(meter.name);
                
                // get length of meter with most data
                if(meter.data.length > maxlength){
                    maxlength = meter.data.length;
                }
            });

            let rowHeaders = rowHeaderArray.join(separator)
            csvData += rowHeaders + newline;
            
            //Get rest of data
            for (step = 0; step < maxlength; step++){
            let rowArray = [];
            
            //for each meter
            this.meterData.forEach((meter)=>{
                //if no data, then add a blank
                if(meter.data[step] === undefined){
                    rowArray.push('');
                    rowArray.push('');
                }else{
                //otherwise add data to the row    
                rowArray.push(moment.utc(meter.data[step].utcRectime).local().format("DD/MM/YYYY HH:mm:ss"));
                rowArray.push(Number(meter.data[step].value));    
                }                
            });
            let row = rowArray.join(',');
            csvData += row + newline;
            }
            
        
        //SaveAsFile("\uFEFF" + csvData,"filename.csv","text/csv;charset=utf-8");
           let blob = new Blob([BOM + csvData],  { type: "text/csv;charset=utf-8" });
            saveAs(blob, "csvMeterData.csv");
            this.loading=false;   
            
        
        },
        
        
        

    },
    
        //Mounted Stage
        mounted() {
        //this.loginNavigator();
        this.finishedMounting = true;
        this.initialLoad();
        	
            //add mock data to chart
            /*for (let i = 0; i < 100; i++) {
            	this.addData();
            }*/
            
        //Axios http get request with username passwor authentication to Navigator API
        //setInterval(() => this.updateDevices(), 5* 60 * 1000)  
    },


          //Created Stage
          created() {
          },
          watch: {
              
              //when selected User dimension changes, then get new tree node/meter root data
              selectedUserDimension: function(val){
                   this.updateMeterTreeRoot();
                },
                selectedTimeRange: function(val){
                    this.setDates(val);
                },
          }
      };
      
      
     

     
  </script>
  
  
  <style scoped>
  
  
      .column.scroll {
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: wrap;
  
      
      }
      
      .level-item {
        flex-shrink: 1;
        padding-right: 10px;
        }
        
      .field.extra-space {
        padding-right: 30px;
        }
        
      .search-result-item {
        font-size:0.8em;
        }
        

       
       .navbar-text {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: -0.4em;
            padding-left: 1em;
        }
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
           padding-top: 4px;
            left: 0;
            text-align: center;
            margin: auto;
        }
       
               
        label.stack{  
            width:200px;       

            display:inline-block;    
            vertical-align:middle; 
        }
            
        .meter-selected{
        color:blue;
        }     

        .node-selected{
        background-color:#0d5a60;
        color:white;
        }
        
           
      
    .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       
       
       

       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }
             
        input:focus{
       outline-color: #002949;
       border-color: #000028;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028;
       }

       select:focus {
       outline-color: #002949 !important;;
       border-color: #000028 !important;;
       shadow-color: #000028;
      box-shadow: 0 0 3px #000028 !important;;
      }

      #body{
  overflow-x: scroll;
}

.x-scrollable-column{
 overflow-x: scroll;
}

   table
{
 overflow-x: scroll;
}
       
       html { 
           overflow-x: scroll !important; 
           }  

           .b-table{
               overflow-x: auto !important;  
           }

           .b-table.table-wrapper{
                overflow-x: auto !important; 
           }
.section{
          padding:5px;
          margin:5px;
      }
      .column{
      height:calc(100vh - 50px);
      overflow-y: auto;
      overflow-x: hidden;
  }   
  </style>